import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ReportOfferFinancialState {
  collectionOfferFinancial: any[];
  paymentOfferFinancial: any[];
  balanceOfferFinancial: any[];
  isLoading: boolean;
  error: string | null;
}

const initialState: ReportOfferFinancialState = {
  collectionOfferFinancial: [],
  paymentOfferFinancial: [],
  balanceOfferFinancial: [],
  isLoading: false,
  error: null,
};

const reportOfferFinancialSlice = createSlice({
  name: 'reportOfferFinancial',
  initialState,
  reducers: {
    setCollectionOfferFinancial: (state, action: PayloadAction<any[]>) => {
      state.collectionOfferFinancial = action.payload;
      state.isLoading = false;
      state.error = null;
    },

    setPaymentOfferFinancial: (state, action: PayloadAction<any[]>) => {
      state.paymentOfferFinancial = action.payload;
      state.isLoading = false;
      state.error = null;
    },

    setBalanceOfferFinancial: (state, action: PayloadAction<any[]>) => {
      state.balanceOfferFinancial = action.payload;
      state.isLoading = false;
      state.error = null;
    },

    setReportOfferFinancialLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },

    setReportOfferFinancialError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  setCollectionOfferFinancial,
  setPaymentOfferFinancial,
  setBalanceOfferFinancial,
  setReportOfferFinancialLoading,
  setReportOfferFinancialError,
} = reportOfferFinancialSlice.actions;

export default reportOfferFinancialSlice.reducer;
